import { DocumentIcon } from '../../core/themes/icons/DocumentIcon';

import ResourceUploadList from './ResourceUploadList';
import ResourceUploadCreate from './ResourceUploadCreate';
import ResourceUploadEdit from './ResourceUploadEdit';

export default {
  list: ResourceUploadList,
  create: ResourceUploadCreate,
  edit: ResourceUploadEdit,
  icon: DocumentIcon
};
